import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModal } from '../modal';

import ModalButton from '../modal_button';
import SignUpModal from '../signup';

import { restoreUser, setUser } from '../../../store/session';

import './index.css';
import { apiFetch } from '../../../utils';

const LoginModal = () => {
    const dispatch = useDispatch();
    const { closeModal } = useModal();

    const sessionUser = useSelector(state => state?.session?.user);

    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const isSessionUser = (value) => {
        return Boolean(value && typeof value === 'object' && !Array.isArray(value) && value.id);
    };

    useEffect(() => {
        if (sessionUser !== null) {
            closeModal();
        }
    }, [sessionUser, closeModal]);

    const validate = () => {
        const newErrors = {};
        if (login.length < 4 || login.length > 60)
            newErrors.login = ['Login (4-60) characters.'];
        if (password.length < 6 || password.length > 32)
            newErrors.password = ['Password (6-32) characters.'];
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        const response = await apiFetch('/user/login', 'POST', {login, password});
        if (!response || response.code !== 'success') {
            setLoading(false);
            setErrors(response.data);
            return;
        };

        const authUser = await dispatch(restoreUser());
        setLoading(false);

        if (authUser) {
            closeModal();
            return;
        }

        if (isSessionUser(response.data)) {
            dispatch(setUser(response.data));
            closeModal();
            return;
        }

        if (!authUser) {
            setErrors({ msg: ['Login succeeded, but the session could not be loaded. Please refresh and try again.'] });
            return;
        }
    };

    const buttonDisabled = login.length < 1 || password.length < 1 || loading;
    const handleButtonDown = (e) => {
        if (e.key !== 'Enter' && e.key !== 'Tab') return;
        e.preventDefault();
        
        const form = e.target.form;
        const index = [...form].indexOf(e.target);
        const nextIndex = index + 1;
        if (index === 1) {
            if (buttonDisabled) return;
            return handleSubmit(e);
        };

        const nextFocus = form[nextIndex];
        nextFocus.focus();
    }

    return (
        <div id='modal-login'>
            <div id='modal-container'>
                <div id='modal-container-login'>
                    <div className='modal-panel-header'>
                        <h2 className='modal-panel-title'>Login</h2>
                        <button
                            type='button'
                            className='button modal-panel-close'
                            title='Close login'
                            onClick={closeModal}
                        >
                            Close
                        </button>
                    </div>

                    <form className='modal-form' onSubmit={handleSubmit}>
                        {errors?.msg && errors.msg.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.login && errors.login.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.password && errors.password.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}

                        <label className="modal-label"> Username or Email
                            <input className="modal-input" type="text" value={login} required
                                autoFocus
                                onKeyDown={handleButtonDown}
                                maxLength={60}
                                onChange={(e) => setLogin(e.target.value)}
                            />
                        </label>

                        <div id="login-password-container">
                            <label className="modal-label"> Password
                                <input className="modal-input" type={!showPassword ? "password" : "text"} value={password} required
                                    onKeyDown={handleButtonDown}
                                    maxLength={32}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <button id='login-show-password'
                                    title='Show Password'
                                    onClick={(e) => {e.preventDefault(); setShowPassword(!showPassword)}}
                                >{showPassword ? <i className="fa-solid fa-eye"/> : <i className="fa-solid fa-eye-slash"/>}</button>
                            </label>
                        </div>

                        <div id='login-buttons'>
                            <button className='login-button'
                                type='submit'
                                disabled={buttonDisabled}
                                title={buttonDisabled ? 'Fill out the form' : 'Login'}
                            >{loading ? 'Loading' : 'Login'}</button>

                                <ModalButton className='forgot-password-button'
                                type='button'
                                    disabled={loading}
                                buttonText={loading ? 'Loading' : 'Forgot Password'}
                                title='Forgot Password'
                                modalComponent={<SignUpModal />}
                            />
                        </div>

                        <ModalButton
                            className={loading ? 'login-button login-signup-button login-signup-button-disabled' : 'login-button login-signup-button'}
                            disabled={loading}
                            type='button'
                            buttonText={loading ? 'Loading' : 'Sign-Up'}
                            title='Create an account'
                            modalComponent={<SignUpModal />}
                        />
                        
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginModal;